import { use } from 'react'

import { AuthContext, type AuthContextValue } from '@/features/auth/AuthContext'

export function useAuth(): AuthContextValue {
  const ctx = use(AuthContext)
  if (!ctx) {
    throw new Error('useAuth debe usarse dentro de <AuthProvider>.')
  }
  return ctx
}
